import { defineStore } from 'pinia'
import type { Composer } from "vue-i18n"

let buckets: BucketMeta[] = new Array<BucketMeta>()


export const useMainStore = defineStore('main', {
    state: () => ({
        buckets: buckets,
        config: null,
        hideIEWarning: false,
        lastVisitedPageNumber: 1,
        indexView: null,
        subForms: [],
        locales: [] as string[],
        dashboard: { ...DEFAULT_DASHBOARD_CONFIG } as DashboardConfig,
        header: { galleries: { ...DEFAULT_HEADER_CONFIG.galleries } } as HeaderConfig,
        active_locale: 'en_GB',
        showShareablesInGalleries: false,
        imageAltTextEnabled: DEFAULT_RESPONSIVE_IMAGE_CONFIG.altTextEnabled,
        uploadLimits: {
            image: DEFAULT_RESPONSIVE_IMAGE_CONFIG.maxUploadBytes,
            video: DEFAULT_VIDEO_TRANSCODE_CONFIG.maxUploadBytes,
            file: DEFAULT_FILE_CONFIG.maxUploadBytes,
            audio: DEFAULT_AUDIO_MAX_UPLOAD_BYTES,
        } as UploadLimits,
    }),
    actions: {
        set_default_locale() {
            const lang = navigator.language || navigator.languages?.[0] || ''
            return lang.startsWith('nl') ? 'nl_NL' : 'en_GB'
        },
        boot(buckets: BucketMeta[], locales: string[], dashboard?: DashboardConfig, header?: HeaderConfig, showShareablesInGalleries?: boolean, imageAltTextEnabled?: boolean, uploadLimits?: UploadLimits) {
            this.setBuckets(buckets)
            this.setLocales(locales)
            this.setDashboardConfig(dashboard ?? DEFAULT_DASHBOARD_CONFIG)
            this.setHeaderConfig(header ?? DEFAULT_HEADER_CONFIG)
            this.showShareablesInGalleries = showShareablesInGalleries ?? false
            this.imageAltTextEnabled = imageAltTextEnabled ?? DEFAULT_RESPONSIVE_IMAGE_CONFIG.altTextEnabled
            if (uploadLimits) this.setUploadLimits(uploadLimits)
            // commit('SET_BUCKETS', req.storeData.buckets);
            // commit('SET_CONFIG', req.storeData.config);
            // commit('SET_HIDE_IE_WARNING', req.storeData.hideIEWarning);
        },
        setBuckets(buckets: BucketMeta[]) {
            this.buckets = buckets
        },
        setLocales(locales: string[]) {
            this.locales = locales

        },
        setActiveLocale(locale: string) {
            const { $i18n } = useNuxtApp()
            ;($i18n as Composer).locale.value = locale === 'nl_NL' ? 'nl' : 'en'
            this.$patch({ active_locale: locale })
        },
        setDashboardConfig(dashboard: DashboardConfig) {
            this.dashboard = {
                layout: dashboard.layout === 'list' ? 'list' : DEFAULT_DASHBOARD_CONFIG.layout,
                groupBuckets: dashboard.groupBuckets ?? DEFAULT_DASHBOARD_CONFIG.groupBuckets,
                groups: (dashboard.groups ?? []).map(group => ({
                    id: group.id,
                    name: group.name,
                })),
            }
        },
        setHeaderConfig(header: HeaderConfig) {
            this.header = {
                galleries: {
                    image: header.galleries?.image ?? DEFAULT_HEADER_CONFIG.galleries.image,
                    video: header.galleries?.video ?? DEFAULT_HEADER_CONFIG.galleries.video,
                    file: header.galleries?.file ?? DEFAULT_HEADER_CONFIG.galleries.file,
                    audio: header.galleries?.audio ?? DEFAULT_HEADER_CONFIG.galleries.audio,
                },
            }
        },
        setImageAltTextEnabled(enabled: boolean) {
            this.imageAltTextEnabled = enabled
        },
        setUploadLimits(limits: Partial<UploadLimits>) {
            this.uploadLimits = { ...this.uploadLimits, ...limits }
        },
        async refreshBuckets() {
            const buckets = await $fetch<ApiSuccess<BucketMeta[]>>('/api/buckets')
            this.buckets = buckets.data
            return this.buckets
        },
        // increment() {
        //   // `this` is the store instance
        //   this.counter++
        // },
    },

})


// import axios from '../plugins/axios';

// export const state = () => ({
//   buckets: null,
//   user: null,
//   config: null,
//   hideIEWarning: false,
//   lastVisitedPageNumber: 1,
//   indexView: null,
//   subForms: [],
// });

// export const mutations = {
//   SET_BUCKETS(_state, buckets) {
//     _state.buckets = buckets;
//   },
//   ADD_BUCKET(_state, bucket) {
//     _state.buckets.push(bucket);
//   },
//   UPDATE_BUCKET(_state, bucket) {
//     const index = _state.buckets.findIndex(b => b._id === bucket._id);
//     _state.buckets.splice(index, 1, bucket);
//   },
//   SET_CONFIG(_state, _config) {
//     _state.config = _config;
//   },
//   SET_USER(_state, user) {
//     _state.user = user;
//   },
//   SET_HIDE_IE_WARNING(_state, shouldHide) {
//     _state.hideIEWarning = shouldHide;
//   },
//   SET_LAST_VISITED_PAGE_NUMBER(_state, pageNumber) {
//     _state.lastVisitedPageNumber = parseInt(pageNumber);
//   },
//   SET_INDEX_VIEW(_state, view) {
//     if (view === 'list' || view === 'grid') {
//       _state.indexView = view;
//     }
//   },
//   ADD_SUBFORM(_state, subForm) {
//     _state.subForms.push(subForm);
//   },
//   CLEAR_SUBFORMS(_state) {
//     _state.subForms = [];
//   },
// };

// export const actions = {
//   nuxtServerInit({ commit }, { req }) {
//     commit('SET_BUCKETS', req.storeData.buckets);
//     commit('SET_CONFIG', req.storeData.config);
//     commit('SET_HIDE_IE_WARNING', req.storeData.hideIEWarning);

//     if (req.session && req.user) {
//       commit('SET_USER', req.user);
//     }
//     if (req.session && req.session['index-view']) {
//       commit('SET_INDEX_VIEW', req.session['index-view']);
//     }
//   },
//   addBucket({ commit }, bucket) {
//     commit('ADD_BUCKET', bucket);
//   },
//   updateBucket({ commit }, bucket) {
//     commit('UPDATE_BUCKET', bucket);
//   },
//   updateBuckets({ commit }, { buckets }) {
//     commit('SET_BUCKETS', buckets);
//   },
//   setLastVisitedPageNumber({ commit }, page) {
//     commit('SET_LAST_VISITED_PAGE_NUMBER', page);
//   },
//   registerSubForm({ commit }, subForm) {
//     commit('ADD_SUBFORM', subForm);
//   },
//   clearSubForms({ commit }) {
//     commit('CLEAR_SUBFORMS');
//   },
//   async login({ commit }, { req, email, password }) {
//     try {
//       const { data: user } = await axios(req).post('/auth/login', {
//         email,
//         password,
//       });
//       commit('SET_USER', user);
//     } catch (err) {
//       const {
//         response: { data },
//       } = err;

//       if (!data) {
//         throw err;
//       }

//       if (data.error === 'unknown user') {
//         throw new Error('unknown user');
//       } else if (data.error === 'incorrect password') {
//         throw new Error('incorrect password');
//       } else {
//         throw new Error('unknown error');
//       }
//     }
//   },
//   async signup({ commit }, { req, name, email, password, invitationCode }) {
//     try {
//       const { data: user } = await axios(req).post('/auth/signup', {
//         name,
//         email,
//         password,
//         invitationCode,
//       });
//       commit('SET_USER', user);
//     } catch (err) {
//       const {
//         response: { data },
//       } = err;

//       if (data && data.error) {
//         throw new Error(data.error);
//       } else {
//         throw err;
//       }
//     }
//   },
//   async hideIEWarning({ commit }) {
//     try {
//       commit('SET_HIDE_IE_WARNING', true);
//       const { data } = await axios().post('/internet-explorer/hide');
//     } catch (err) {
//       const {
//         response: { data },
//       } = err;
//       if (data && data.error) {
//         throw new Error(data.error);
//       } else {
//         throw err;
//       }
//     }
//   },
//   async updateIndexView({ commit }, view) {
//     try {
//       commit('SET_INDEX_VIEW', view);
//       await axios().post('/session/index-view', {
//         view,
//       });
//     } catch (err) {
//       const {
//         response: { data },
//       } = err;
//       if (data && data.error) {
//         throw new Error(data.error);
//       } else {
//         throw err;
//       }
//     }
//   },
// };

// export const getters = {
//   userBuckets: state =>
//     state.user
//       ? state.buckets
//           .filter(bucket => !bucket.private)
//           .filter(bucket => !state.user.buckets || state.user.buckets.includes(bucket.slug))
//       : [],
// };
